var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentWithDollarSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26156_57545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99795 2.74805C3.67548 2.74805 3.41406 3.00946 3.41406 3.33194V12.6692C3.41406 12.9916 3.67548 13.253 3.99795 13.253H7.33317C7.74738 13.253 8.08317 13.5888 8.08317 14.003C8.08317 14.4173 7.74738 14.753 7.33317 14.753H3.99795C2.84705 14.753 1.91406 13.8201 1.91406 12.6692V3.33194C1.91406 2.18104 2.84705 1.24805 3.99795 1.24805H12.0013C13.1522 1.24805 14.0852 2.18104 14.0852 3.33194V5.33305C14.0852 5.74726 13.7494 6.08305 13.3352 6.08305C12.921 6.08305 12.5852 5.74726 12.5852 5.33305V3.33194C12.5852 3.00946 12.3238 2.74805 12.0013 2.74805H3.99795Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.69336C12.2761 6.69336 12.5 6.91722 12.5 7.19336V8.80908C12.5 9.08522 12.2761 9.30908 12 9.30908C11.7239 9.30908 11.5 9.08522 11.5 8.80908V7.19336C11.5 6.91722 11.7239 6.69336 12 6.69336Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1859 9.51452C11.3437 9.45238 10.7805 9.92845 10.7171 10.3474C10.6758 10.6204 10.4209 10.8082 10.1479 10.7669C9.87487 10.7256 9.68703 10.4708 9.72836 10.1977C9.89864 9.07265 11.1119 8.43255 12.2595 8.51724C12.5349 8.53756 12.7417 8.77728 12.7214 9.05267C12.701 9.32807 12.4613 9.53484 12.1859 9.51452Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.1934C12.2761 13.1934 12.5 13.4172 12.5 13.6934V15.3091C12.5 15.5852 12.2761 15.8091 12 15.8091C11.7239 15.8091 11.5 15.5852 11.5 15.3091V13.6934C11.5 13.4172 11.7239 13.1934 12 13.1934Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8522 12.2303C14.1252 12.2716 14.3131 12.5265 14.2717 12.7995C14.1015 13.9246 12.8882 14.5647 11.7406 14.48C11.4652 14.4597 11.2584 14.2199 11.2787 13.9446C11.299 13.6692 11.5388 13.4624 11.8142 13.4827C12.6564 13.5449 13.2196 13.0688 13.283 12.6499C13.3243 12.3768 13.5792 12.189 13.8522 12.2303Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7536 8.51715C12.7678 8.46896 13.8037 8.92306 14.2257 9.77774C14.3479 10.0253 14.2463 10.3252 13.9987 10.4474C13.7511 10.5697 13.4513 10.4681 13.329 10.2204C13.1334 9.82429 12.5454 9.48066 11.8011 9.51602C11.5253 9.52913 11.291 9.31615 11.2779 9.04032C11.2648 8.76449 11.4778 8.53026 11.7536 8.51715Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0405 12.5518C10.2881 12.4295 10.5879 12.5312 10.7102 12.7788C10.9058 13.1749 11.4938 13.5185 12.2381 13.4832C12.5139 13.4701 12.7482 13.6831 12.7613 13.9589C12.7744 14.2347 12.5614 14.4689 12.2856 14.4821C11.2713 14.5302 10.2355 14.0761 9.8135 13.2215C9.69125 12.9739 9.79287 12.674 10.0405 12.5518Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5529 10.7785C10.6764 10.5315 10.9767 10.4314 11.2237 10.5548L13.2237 11.5548C13.4707 11.6783 13.5708 11.9787 13.4473 12.2257C13.3238 12.4727 13.0235 12.5728 12.7765 12.4493L10.7765 11.4493C10.5295 11.3258 10.4294 11.0254 10.5529 10.7785Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91602 5C4.91602 4.58579 5.2518 4.25 5.66602 4.25H9.66768C10.0819 4.25 10.4177 4.58579 10.4177 5C10.4177 5.41421 10.0819 5.75 9.66768 5.75H5.66602C5.2518 5.75 4.91602 5.41421 4.91602 5Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91602 7.66797C4.91602 7.25376 5.2518 6.91797 5.66602 6.91797H6.9999C7.41412 6.91797 7.7499 7.25376 7.7499 7.66797C7.7499 8.08218 7.41412 8.41797 6.9999 8.41797H5.66602C5.2518 8.41797 4.91602 8.08218 4.91602 7.66797Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26156_57545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentWithDollarSign);
export default __webpack_public_path__ + "static/media/icon-document-with-dollar-sign.b01247f67f5dc9eec22f13be1b0c79f1.svg";
export { ForwardRef as ReactComponent };